import { zipStatic } from '../operators/zip';
export var zip = zipStatic;
//# sourceMappingURL=zip.js.map